<nav
  aria-label="Utility Navigation"
  class="utility-nav-desktop bg-brand-black utility-nav"
  >
  <div>
    <div class="container">
      @if (headerMap.utilityNav) {
        <ul>
          @for (item of headerMap.utilityNav; track item) {
            <li>
              <a
                tabindex="0"
                class="utility-item"
                [href]="modifyUrl(item.linkItem.href)"
                target="_blank"
                ><span class="control-group"
                ><span style="order: 1">{{ item.linkItem.title }}</span
                >@if (item.icon) {
                <span
                  class="shared-icon-container"
                  [innerHtml]="icons[item.icon]"
                ></span>
                }</span
              ></a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</nav>

<header
  class="header"
  [ngClass]="{ 'header-open': isMobileNavShown }"
  >
  <div>
    <div class="container">
      <nav aria-label="Main Navigation" class="bg-brand-blue main-nav">
        <a
          class="header-logo-link"
          [href]="brandConfig.headerOverrides.homeUrl"
          target="_blank"
          ><span class="control-group"
          ><span
          ><figure class="image">
          <img
            [alt]="brandConfig.logoAlt"
            loading="lazy"
            decoding="async"
            data-nimg="1"
                  style="
                    color: transparent;
                    object-fit: contain;
                    object-position: left center;
                  "
            [src]="brandConfig.logoPath"
          /></figure></span></span
        ></a>
        @if (brandConfig.key === 'windownation') {
          <a tabindex="0" class="request-call" target="_blank" [href]="modifyUrl(headerMap.ctaButton.href)">
            <span class="control-group">
              <span>{{headerMap.ctaButton.title}}</span>
            </span>
          </a>
        }
        <div class="header-nav-toggle-container">
          <button
            type="button"
            class="header-nav-toggle"
            (click)="toggleMobileNavigation()"
            >
          <span class="visually-hidden">Close Nav</span
            >@if (!isMobileNavShown) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              role="img"
              class="IconButton_icon__A_ory"
              aria-hidden="true"
              style="
                color: var(--icon-color, currentColor);
                width: var(--icon-width, var(--icon-size, 24px));
                height: var(--icon-height, var(--icon-size, 24px));
              "
              >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M3 12h18M3 6h18M3 18h18"
              ></path></svg
              >
              }@if (isMobileNavShown) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                role="img"
                class="IconButton_icon__A_ory"
                aria-hidden="true"
              style="
                color: var(--icon-color, currentColor);
                width: var(--icon-width, var(--icon-size, 24px));
                height: var(--icon-height, var(--icon-size, 24px));
              "
                >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M18 6 6 18M6 6l12 12"
                ></path>
              </svg>
            }
          </button>
        </div>
        @if (isMobileNavShown) {
          <div class="header-mobile-nav">
            @if (brandConfig.key === 'windownation') {
              <div class="bg-brand-blue request-call-frame">
                <a
                  tabindex="0"
                  class="request-call"
                  target="_blank"
                  [href]="modifyUrl(headerMap.ctaButton.href)"
                  ><span class="shared_control-group__3ZCLX"
                  ><span>{{headerMap.ctaButton.title}}</span></span
                  ></a
                  >
                </div>
            }
              <nav
                aria-label="Utility Navigation"
                class="bg-brand-black utility-nav"
                >
                <div>
                  <div class="container">
                    <ul>
                      @for (item of headerMap.utilityNav; track item) {
                        <li>
                          <a
                            tabindex="0"
                            target="_blank"
                            class="utility-item"
                            [href]="modifyUrl(item.linkItem.href)"
                            ><span class="control-group"
                            ><span style="order: 1">{{ item.linkItem.title }}</span
                            ><span
                            class="shared-icon-container"
                            [innerHtml]="icons[item.icon]"
                          ></span></span
                        ></a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        }
      </nav>
    </div>
  </div>
</header>
